import { connect } from 'react-redux';
import React, { Component } from "react";
import { Card, CardBody, CardHeader, CardTitle, Row, Col, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { PanelHeader } from "components";
import Button from "components/CustomButton/CustomButton";
import { projectActions } from 'actions';
import { Link } from 'react-router-dom';
import SweetAlert from "react-bootstrap-sweetalert";
import { permissions } from '../../helpers';
import EditProjectLink from './EditProjectLink';
import ReactAJAXTable from '../../components/ReactAJAXTable/ReactAJAXTable';
import Clearfix from 'components/Custom/Clearfix';
import ButtonWithTooltip from '../../components/Custom/ButtonWithTooltip';
import loopBackAPIAdapter from '../../components/ReactAJAXTable/adapters/loopBackAPIAdapter';
import User from '../../entities/User'
import { permissionConstants, roleConstants } from '../../constants'
import ErrorModal from "../Components/ErrorModal"
import { withTranslation } from 'react-i18next';

import { projectService } from '../../services';


class Projects extends Component {

  constructor(props) {
    super(props);
    this.state = {
      alert: null,
      error: null
    }
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.delete = this.delete.bind(this);
    
  }

  componentWillMount(){
    this.fetchProjects();
  }


  async fetchProjects(){
    const user = User.current()
    try {
        let filter = {include: 'users'};
        if (permissions.grant('SHOW_ONLY_OWN_PROJECTS')) {
            //const user = User.current()
            const userId = user.id;
            filter = { 
                include: 'users',
                where: {
                    members: {
                        like: "%\"" + userId + "\"%"
                    }
                }
            };
        }
        //let projects = await projectService.getAll(filter);
        let projects = await projectService.getAllByUser(user);
        localStorage.setItem('projects', JSON.stringify(projects));
        //this.setState( { projects });
        //this.fetchData(projects);
    } catch(err){
      console.log(err);
    }
}


  componentWillReceiveProps(nextProps) {
    if (nextProps.error) {
      this.setState({ error: nextProps.error });
    }

    if (nextProps.projects.deletedId && nextProps.projects.items) {    
      this.fetchProjects();
    }
  }



  deleteConfirm(id) {
    const { t } = this.props;
    
    if (id == 0) {
      this.setState({
        alert: null
      });
    }
    else
      this.setState({
        alert: (
          <SweetAlert
            warning
            customClass="custom-sweet-alert"
            style={{ display: "block" }}
            title={t("Cancellazione del progetto")}
            onConfirm={() => this.delete(id)}
            onCancel={() => this.deleteConfirm(0)}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText={t("SI")}
            cancelBtnText={t("NO")}
            showCancel
          >
            {t("Sei sicuro?")}
          </SweetAlert>
        )
      });
  }

  delete(id) {
    const { dispatch } = this.props;
    if (id) {
      this.setState({
        alert: null
      });
      dispatch(projectActions.delete(id));
    }
  }

  render() {
    const { t } = this.props;
    const projects = this.props.projects;
    const { error } = this.state;
    let data = [];

    if (projects.items) {
      // ReactTable data
      data = projects.items.map((item, key) => {
        let actions = null;

        if (permissions.grant(permissionConstants.EDIT_PROJECTS)) {
          actions = (
            <div className="actions-right">
              <EditProjectLink id={item.id} />
              {" "}
              <ButtonWithTooltip
                id={"deleteProject_" + item.id}
                onClick={() => { this.deleteConfirm(item.id); }}
                color="danger"
                size="sm"
                round
                icon
                tooltipText={t("Elimina")}
              >
                <i className="fa fa-times" />
              </ButtonWithTooltip>
              {" "}
            </div>
          );
        }
        else if (User.isWithinGroup(this.props.loggedinUser, roleConstants.CAT)) {
          actions = (
            <div className="actions-right">
              <EditProjectLink id={item.id} />
            </div>
          );
        }

        return {
          id: key,
          name: item.name,
          description: item.description,
          actions: actions
        };
      })

    }

    return (
      <div>
        {this.state.alert}
        <PanelHeader size="sm" />
        {error && <ErrorModal error={error} onClickHandler={() => { this.setState({ error: null }) }} />}

        <div className="content">
          <Row>
            <Col xs={12} md={12}>
              <Card>
                <CardHeader>
                  <CardTitle>
                    {t("Elenco progetti")}
                    {
                      permissions.grant(permissionConstants.CREATE_PROJECTS)
                      &&
                      <span className="pull-right">
                        <Link to={"/projects/edit/0"} className="custom-display-inline-block custom-v-align-top">
                          <Button color="primary" round size="sm" className="custom-no-margin">{t("Nuovo")}</Button>
                        </Link>
                      </span>
                    }
                    <Clearfix />
                  </CardTitle>
                </CardHeader>
                <CardBody>
                  <ReactAJAXTable
                    filters={projects.filters} 
                    AJAXAdapter={loopBackAPIAdapter} // Adapter per filtri (vengono passati all'actionCreator `actionCreator.filterCount` e `actionCreator.filter`)
                    dispatch={this.props.dispatch} // Methodo `dispatch` di Redux
                    actionCreator={projectActions} // Action creator (deve implementare il metodo `filterCount`)
                    filtered_count={projects.filtered_count} // Count dei record attualmente filtrati
                    loading={projects.loading} // Determina se la tabella si sta caricando
                    pages={projects.pages} // Totale pagine dei record correntemente filtrati
                    limit={projects.limit} // Numero di record per pagina
                    noRecordText={t("Nessun progetto trovato")} // Testo in caso di nessun record
                    columns={[
                      {
                        Header: t("Nome"),
                        accessor: "name",
                        Filter: ({filter, onChange}) => (
                          <input
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : ''}
                            placeholder={t("Search...")}
                            style={{
                              width: '100%'
                            }}
                          />
                        ),
                      },
                      {
                        Header: t("Descrizione"),
                        accessor: "description",
                        Filter: ({filter, onChange}) => (
                          <input
                            onChange={event => onChange(event.target.value)}
                            value={filter ? filter.value : ''}
                            placeholder={t("Search...")}
                            style={{
                              width: '100%'
                            }}
                          />
                        )
                      },
                      {
                        Header: t("Azioni"),
                        accessor: "actions",
                        sortable: false,
                        filterable: false,
                        resizable: false
                      }
                    ]} // Definizione delle colonne della tabella (secondo il componente `ReactTable`)
                    data={projects.loading ? [] : data} // Record da visualizzare (secondo il componente `ReactTable`)
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}

/* Container component */
function mapStateToProps(state) {
  const { authentication, projects } = state;
  return {
    projects,
    loggedinUser: authentication.user,
    error: projects.error
  };
}

const connectedProjects = withTranslation()(connect(mapStateToProps)(Projects));
/* /Container component */

export { connectedProjects as Projects };



// WEBPACK FOOTER //
// ./src/views/Projects/Projects.jsx